import XEUtils from 'xe-utils';
import GlobalConfig from '../v-x-e-table/src/conf';
import DomZIndex from 'dom-zindex';
export function isEnableConf(conf) {
    return conf && conf.enabled !== false;
}
export function isEmptyValue(cellValue) {
    return cellValue === null || cellValue === undefined || cellValue === '';
}
export function parseFile(file) {
    var name = file.name;
    var tIndex = XEUtils.lastIndexOf(name, '.');
    var type = name.substring(tIndex + 1, name.length).toLowerCase();
    var filename = name.substring(0, tIndex);
    return { filename: filename, type: type };
}
export function nextZIndex() {
    return DomZIndex.getNext();
}
export function getLastZIndex() {
    return DomZIndex.getCurrent();
}
export function hasChildrenList(item) {
    return item && item.children && item.children.length > 0;
}
export function getFuncText(content) {
    return content ? XEUtils.toValueString(GlobalConfig.translate ? GlobalConfig.translate('' + content) : content) : '';
}
export function formatText(value, placeholder) {
    return '' + (isEmptyValue(value) ? (placeholder ? GlobalConfig.emptyCell : '') : value);
}
/**
 * 判断值为：'' | null | undefined 时都属于空值
 */
export function eqEmptyValue(cellValue) {
    return cellValue === '' || XEUtils.eqNull(cellValue);
}
